import React, { createContext, useContext, useState, useCallback } from 'react';

const CacheContext = createContext();

export const CacheProvider = ({ children }) => {
  const [cache, setCache] = useState({
    campaigns: { data: null, timestamp: null },
    products: { data: null, timestamp: null },
    storeConfig: { data: null, timestamp: null },
    coupons: { data: null, timestamp: null },
    videos: { data: null, timestamp: null }
  });

  // Cache expira após 5 minutos (300000ms)
  const CACHE_DURATION = 300000;

  const getCachedData = useCallback((key) => {
    const cached = cache[key];
    if (!cached || !cached.data) return null;
    
    const now = Date.now();
    if (now - cached.timestamp > CACHE_DURATION) {
      return null; // Cache expirado
    }
    
    return cached.data;
  }, [cache]);

  const setCachedData = useCallback((key, data) => {
    setCache(prev => ({
      ...prev,
      [key]: {
        data,
        timestamp: Date.now()
      }
    }));
  }, []);

  const clearCache = useCallback((key) => {
    if (key) {
      setCache(prev => ({
        ...prev,
        [key]: { data: null, timestamp: null }
      }));
    } else {
      // Limpar todo o cache
      setCache({
        campaigns: { data: null, timestamp: null },
        products: { data: null, timestamp: null },
        storeConfig: { data: null, timestamp: null },
        coupons: { data: null, timestamp: null },
        videos: { data: null, timestamp: null }
      });
    }
  }, []);

  const value = {
    getCachedData,
    setCachedData,
    clearCache
  };

  return (
    <CacheContext.Provider value={value}>
      {children}
    </CacheContext.Provider>
  );
};

export const useCache = () => {
  const context = useContext(CacheContext);
  if (!context) {
    throw new Error('useCache must be used within CacheProvider');
  }
  return context;
};
